import { createApp } from 'vue'
import FormAddressField from './FormAddressField'

const el = '.kb-component--form-address-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormAddressFieldDOM) => {
            const component = createApp(FormAddressField).use(Store)
            component.mount(FormAddressFieldDOM)
        })
    }
}
